import { Link } from "react-router";
import { useRealm, useT } from "~/util/Lang";
import { BookIcon } from "../site/icons/Book";

export type WikiLinkData = {
  id: number;
  slug?: string;
  name: string;
};

export function WikiLink(props: { page: WikiLinkData }) {
  const page = props.page;

  return (
    <span style={{}}>
      <Link
        to={`/wiki/${page.id}`}
        style={{
          textDecoration: "none",
        }}
      >
        <span
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            width: 19,
            height: 19,
            marginTop: "-2px",
            marginRight: 2,
          }}
        >
          <BookIcon />
        </span>
        {props.page.name}
      </Link>
    </span>
  );
}
